'use client';

import type { Icon, Scheme } from '@personly/libs-types';
import { IconSelect } from '@personly/libs-widgets';
import { useOptions } from '@personly/libs-hooks';
import { useSchemes } from '@personly/libs-providers';

type LocalizedScheme = Scheme & { title: string };

interface Props {
  schemes: Array<LocalizedScheme>;
  schemeIcons: Icon[];
}

const SchemeSelect = ({ schemes, schemeIcons }: Props) => {
  const { schemeHandle, setSchemeHandle } = useSchemes();

  const schemeIcon = (handle: string) =>
    schemeIcons.find((icon) => icon.handle === handle);

  const { options: schemeOptions, selectedOption: selectedSchemeOption } =
    useOptions(
      schemes,
      null,
      schemeHandle,
      ({ title }) => title,
      ({ id }) => id
    );

  const options = schemeOptions.map((option) => option.value);
  const selectedOption = selectedSchemeOption ? selectedSchemeOption.value : '';

  return (
    <IconSelect
      icon={schemeIcon}
      options={options}
      selectedOption={selectedOption}
      setSelectedOption={setSchemeHandle}
    />
  );
};

export default SchemeSelect;
